'use strict';

var Utils = require('../utils/utils');
var Megamenu = require('../megamenu/megamenu');
var MegamenuVisibility = require('../megamenu/lib/visibility');

// Constructor
var LangNav = function(config) {

  var self = this;
  var $document = $(document);

  self.config = {
    'button'        :  '.lang-nav__button',
    'menu'          :  '.lang-nav__menu',
    'langs'         :  '.lang-nav__langs',
    'megamenuItem'  :  '.megamenu__item'
  }

  var $button = $(self.config.button);
  var $menu = $(self.config.menu);
  var $langs = $(self.config.langs);
  var $megamenuItem = $(self.config.megamenuItem);

  self.clickHandler = function() {
    $button.on('click.langNav', new Utils().throttle(function() {
      self.menuVisibility();
    }, 300));
  }

  self.documentClickHandler = function() {
    $document.on('click.langNav', function(e) {
      if (!$(e.target).closest($menu).length) {
        if ($menu.hasClass('is-visible') && !$menu.hasClass('velocity-animating')) {
          self.hideMenu();
        }
      }
    });
  }

  self.menuVisibility = function() {
    if ($menu.hasClass('is-visible') && !$menu.hasClass('velocity-animating')) {
      self.hideMenu();
    } else if (!$menu.hasClass('velocity-animating')) {
      self.showMenu();
    }
  }

  self.menuInitialSize = function() {
    var size = {};
    size.width = $button.outerWidth();
    size.height = self.menuInitialHeightHandler();
    return size;
  }

  self.menuInitialHeightHandler = function() {
    var height;
    var largeViewports = function() {
      height = 0;
    };
    var smallViewports = function() {
      height = $button.outerHeight();
    };
    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
    return height;
  }

  self.menuFinalSize = function() {
    var size = {};
    $menu.css('display: block; visibility: hidden;');
    size.width = $menu.outerWidth();
    size.height = $menu.outerHeight();
    $menu.removeAttr('style');
    return size;
  }

  self.setInitialMenuSize = function() {
    var size = self.menuInitialSize();
    $menu.css({width: size.width, height: size.height});
  }

  self.menuOpacityDurationHandler = function() {
    var duration;
    var largeViewports = function() {
      duration = 0;
    };
    var smallViewports = function() {
      duration = 140;
    };
    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
    return duration;
  }

  self.showMenu = function() {

    var size = self.menuFinalSize();

    self.setInitialMenuSize();

    var delay = 0;

    if ($megamenuItem.hasClass('is-visible')) {
      delay = 250;
      self.hideMegamenu();
    }

    $menu
      .velocity('stop')
      .velocity({
        opacity: 1
      },{
        display: 'block',
        delay: delay,
        duration: self.menuOpacityDurationHandler()
      })
      .velocity({
        width: size.width,
        height: size.height
      },{
        easing: 'easeOutQuart',
        duration: 180,
        complete: function() {
          $menu.addClass('is-visible');
          $langs.velocity({
            opacity: 1
          });
        }
      });
  }

  self.hideMenu = function() {

    var size = self.menuInitialSize();

    $langs
      .velocity('stop')
      .velocity({
        opacity: 0
      },{
        duration: 120,
        complete: function() {
          $menu
            .velocity('stop')
            .velocity({
              width: size.width,
              height: size.height
            },{
              easing: 'easeOutQuart',
              duration: 180
            })
            .velocity({
              opacity: 0
            },{
              display: 'none',
              duration: self.menuOpacityDurationHandler(),
              complete: function() {
                $menu
                  .removeClass('is-visible')
                  .removeAttr('style');
              }
            });
        }
      });
  }

  self.hideMegamenu = function() {

    var megamenuConfig = new Megamenu().config;

    new MegamenuVisibility({
      item: megamenuConfig.navAlphaLevelItem,
      link: megamenuConfig.navAlphaLevelLink,
      megamenuItem: megamenuConfig.megamenuItem,
      megamenuItemGrid: megamenuConfig.megamenuItemGrid,
      mainHeader: megamenuConfig.mainHeader
    }).hideCurrentSubnavs(null, null, true);
  }

  self.init = function() {
    self.clickHandler();
    self.documentClickHandler();
  }
};

module.exports = LangNav;
